var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:flex h-full"},[_c('div',{staticClass:"md:w-3/5 md:px-5 pb-2 md:h-full border-t-4 md:border-none"},[_vm._t("list")],2),_c('div',{staticClass:"md:w-2/5 flex-grow-0 overflow-x-hidden"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }